export function formatRelativeTime(date: Date): string {
	const minutes = Math.floor((Date.now() - date.getTime()) / 60000);

	if (minutes < 1) {
		return 'Just now';
	}
	if (minutes < 60) {
		return `${minutes}min ago`;
	}

	const hours = Math.floor(minutes / 60);
	if (hours < 24) {
		return `${hours}h ago`;
	}

	return `${Math.floor(hours / 24)}d ago`;
}
